
import React from 'react';
import { StripeEmbeddedButton } from './StripeEmbeddedButton';

export const PremiumFeatures: React.FC = () => {
  return (
    <div className="bg-gradient-to-br from-green-50/80 to-green-50 p-8 rounded-xl border border-green-100 shadow-soft">
      <div className="space-y-6">
        <div className="space-y-3">
          <h3 className="text-2xl font-semibold text-gray-900">Unlock Premium Features</h3>
          <p className="text-gray-600 leading-relaxed">
            Gain full control over your PEO relationship with advanced pricing tracking, seamless provider transitions, and dedicated support.
          </p>
        </div>
        
        <div className="space-y-4">
          <div className="glass-card p-4 backdrop-blur-sm border-white/30 hover:shadow-md transition-all duration-300">
            <h4 className="font-semibold text-gray-900 mb-1">Real-Time Pricing Monitoring</h4>
            <p className="text-gray-600">Ensure your actual costs match your proposal and stay informed about any changes.</p>
          </div>
          
          <div className="glass-card p-4 backdrop-blur-sm border-white/30 hover:shadow-md transition-all duration-300">
            <h4 className="font-semibold text-gray-900 mb-1">Independent Record-Keeping</h4>
            <p className="text-gray-600">Securely store and update data outside your PEO's system for leverage, easy access, and flexibility.</p>
          </div>
          
          <div className="glass-card p-4 backdrop-blur-sm border-white/30 hover:shadow-md transition-all duration-300">
            <h4 className="font-semibold text-gray-900 mb-1">Effortless Transitions</h4>
            <p className="text-gray-600">Quickly compare new quotes and switch PEOs without administrative headaches.</p>
          </div>
        </div>

        <StripeEmbeddedButton />
      </div>
    </div>
  );
};
